import { Box, Typography } from "@mui/material";
import {
  DivisionDescription,
  DivisionImage,
  InfoCompanyDivisionContainer,
  InfoCompanyDivisionContent,
} from "../../styles/InfoCompanyDivision";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";

export function InfoCompanyDivision() {
  return (
    <>
      <InfoCompanyDivisionContainer>
        <InfoCompanyDivisionContent>
          <DivisionImage src={image1} />
          <DivisionDescription>
            <Typography 
              style={{
                fontSize: '24px',
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Your benefits at a glance:
            </Typography>
            <ul>
              <li>
                Customized solutions for your information system using standard
                EDI transactions
              </li>
              <li>24/7 service</li>
              <li>Quick and reliable information exchange</li>
            </ul>
          </DivisionDescription>
        </InfoCompanyDivisionContent>
        
        <InfoCompanyDivisionContent>
          <DivisionImage src={image2} />
          <DivisionDescription>
            <Typography 
              style={{
                fontSize: '24px',
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Webshop benefits:
            </Typography>
            <ul>
              <li>
                Available anytime, anywhere: access from any mobile device,
                available 24/7
              </li>
              <li>Instant order confirmation</li>
              <li>Easy ordering with our new online catalog</li>
            </ul>
          </DivisionDescription>
        </InfoCompanyDivisionContent>
      </InfoCompanyDivisionContainer>
    </>
  );
}
